  
  export default (state = null, action) => {
    switch (action.type) {
      case 'SETDADOS':
        return { ...action.dados };
      default:
        return state;
    }
  };